'use client'

import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { AN_TRUONG_IMAGES, AN_TRUONG_PRODUCTS } from './an-truong.constants'

export const HeroSection = () => {
  const t = useTranslations('landing_an_truong.hero')

  const handleScrollToProduct = () => {
    const targetId = AN_TRUONG_PRODUCTS[0]?.id || 'ecc-pants'
    const element = document.getElementById(targetId)
    if (element) {
      const yOffset = -80
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  return (
    <section
      role='button'
      tabIndex={0}
      onClick={handleScrollToProduct}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleScrollToProduct()
        }
      }}
      className='relative w-full cursor-pointer overflow-hidden bg-black aspect-[375/550] md:aspect-[1920/788]'
    >
      {/* Mobile Image */}
      <div className='relative size-full md:hidden'>
        <Image
          src={AN_TRUONG_IMAGES.hero.mobile}
          alt={t('alt')}
          fill
          priority
          sizes='100vw'
          className='pointer-events-none object-cover'
        />
      </div>

      {/* Desktop Image */}
      <div className='relative hidden size-full md:block'>
        <Image
          src={AN_TRUONG_IMAGES.hero.desktop}
          alt={t('alt')}
          fill
          priority
          sizes='100vw'
          className='pointer-events-none object-cover'
        />
      </div>
    </section>
  )
}
